<template>
  <span>
    <!-- Tab -->
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Vessel Name</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.vessel_id"
              :suggestions="vessels"
              placeholder="Select Vessel name"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Requsition Number</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.requisition_no"
              class="form-control"
              autocomplete="off"
              placeholder="Requsition Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Is Approved on Vessel</label>
          <div class="col-sm-9">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_approved_on_vessel"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Approved on Vessel Date</label>
          <div class="col-sm-8">
            <my-datepicker
              :date.sync="form.approved_on_vessel_date"
              placeholder="Enter Approved on Vessel Date"
            ></my-datepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Is Approved at Office</label>
          <div class="col-sm-9">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_approved_at_office"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Approved at office Date</label>
          <div class="col-sm-8">
            <my-datepicker
              :date.sync="form.approved_at_office_date"
              placeholder="Enter Approved at office Date"
            ></my-datepicker>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "RequisitonFormWidget",
  props: ["form"],
  data() {
    return {
      vessels: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("requisitions/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
    },
  },
};
</script>
